import React from 'react';
import PropTypes from "prop-types";
import Card from "../../Common/Card";
import intl from "react-intl-universal";
import styles from './index.module.scss';

class CardItem extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        cover: '',
        title: '',
        starValue: 0,
        description: '',
        label: {},
        hoverable: true,
        hoverContent: ''
    };

    static propTypes = {
        cover: PropTypes.string, // 封面图
        title: PropTypes.string, // 标题
        starValue: PropTypes.number, // 价值多少颗星星
        // 描述
        description: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        label: PropTypes.object, // 右上角标签相关信息  visible-是否展示  style-标签样式  text-文案
        hoverable: PropTypes.bool, // 是否可以hover
        // hover弹层内容
        hoverContent: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ])
    };

    componentDidMount() {
    }


    render() {
        const {
            cover,
            title,
            starValue,
            description,
            label,
            hoverable,
            hoverContent
        } = this.props;

        const meta = (
            <React.Fragment>
                <p className="title" title={title}>{title}</p>
                <div className="star-value">
                    <label className="value">{starValue}</label>
                    <span className="icon-star"/>
                </div>
            </React.Fragment>
        );

        const footer = (
            <React.Fragment>
                {
                    description && <div className="description">{description}</div>
                }
            </React.Fragment>
        )

        return (
            <Card
                className="mine-card"
                cover={cover}
                meta={meta}
                footer={footer}
                label={label}
                hoverable={hoverable}
                hoverContent={hoverContent}
            />
        )
    }
}
export default CardItem;